import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import config from "../../config/config.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc.jsx";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import constants from '../../constant.js';

const CustomerDocs = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const clientId = localStorage.getItem('clientId');

    const token = localStorage.getItem('token');
    const ctId = localStorage.getItem('ctId');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [statusFilter, setStatusFilter] = useState('');
    const [cityFilter, setCityFilter] = useState(() => {
        const cityExists = cities.some(city => city.city_id === ctId);
        return cityExists ? ctId : (cities.length > 0 ? cities[0].city_id : null);
    });
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddDocument, setOpenAddDocument] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [documentId, setDocumentId] = useState('');
    const [documentName, setDocumentName] = useState('');
    const [city, setCity] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [noOfImages, setNoOfImages] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [galleryRestricted, setGalleryRestricted] = useState(false);
    const [documentRequired, setDocumentRequired] = useState(false);
    const [documentNumberRequired, setDocumentNumberRequired] = useState(false);

    const [message,setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    useEffect(() => {
        fetchDocumentsData();
    }, [cityFilter]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter) || Boolean(cityFilter)
        );
    };

    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1);

    const fetchDocumentsData = async () => {
        try {
            const cityId = cityFilter;
            const url = `${serverUrl}/customer/get_required_documents`;
            const timestamp = new Date().getTime();
            const obj={
                token: token, city_id: cityId, timestamp: timestamp
            }
            const response =  await makeGetRequestToUrl(url, obj);
            if(response.flag == 200){
                setRows(response.data);
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    const handleOpenAddDocument = () => {
        setOpenAddDocument(true);
        setEditMode(false);
        setDocumentId('');
        setDocumentName('');
        setCity(cityFilter);
        setDocumentType('');
        setNoOfImages('');
        setIsActive(true);
        setGalleryRestricted(false);
        setDocumentRequired(false);
        setDocumentNumberRequired(false);
    };

    const handleCloseAddDocument = () => {
        setOpenAddDocument(false);
        setEditMode(false);
    };

    const handleOpenEditModal = (row) => {
        setOpenAddDocument(true);
        setEditMode(true);
        setDocumentId(row.document_id);
        setDocumentName(row.document_name);
        setCity(row.city_id);
        setDocumentType(constants.CustomerDocumentTypes[row.document_type] || '');
        setNoOfImages(row.no_of_images);
        setIsActive(row.is_active);
        setGalleryRestricted(row.is_gallery_restricted);
        setDocumentRequired(row.is_required);
        setDocumentNumberRequired(row.is_doc_number_required);
    };

    const handleSubmit = async () => {
        const token = localStorage.getItem('token');
        const documentTypeId = parseInt(
            Object.entries(constants.CustomerDocumentTypes).find(([_, value]) => value === documentType)?.[0] || 0
        );
        if(documentName==""){
            setMessage('Document name is required');
            showSnackbar(true);
            return;
        }
        if(documentTypeId==0){
            setMessage('Document type is required');
            showSnackbar(true);
            return;
        }
        if(city==""){
            setMessage('City is required');
            showSnackbar(true);
            return;
        }
        if(noOfImages==""){
            setMessage('No of images is required');
            showSnackbar(true);
            return;
        }

        const payload = {
            token: token,
            document_name: documentName,
            document_type: documentTypeId,
            city_id: city,
            client_id: parseInt(clientId),
            no_of_images: parseInt(noOfImages) || 0,
            is_gallery_restricted: galleryRestricted ? 1 : 0,
            is_active: isActive ? 1 : 0,
            is_required: documentRequired ? 1 : 0,
            is_doc_number_required: documentNumberRequired ? 1 : 0,
        };

        if (editMode && documentId) {
            payload.document_id = documentId;
        }

        try {
            const url = operationsUrl + '/panel/create_and_update_user_docs';
            const response = await makePostRequestToUrl(url,payload);

            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if (response.flag === 200) {
                console.log('Document saved successfully:', response.message);
                setMessage('Document saved successfully');
                showSnackbar(true);
                handleCloseAddDocument();
                fetchDocumentsData();
            } else {
                console.error('Failed to save document:', response.message);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Customer Documents
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                {/* Filter controls */}
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddDocument}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Document
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                <TableSortLabel
                                    active={orderBy === 'document_id'}
                                    direction={orderBy === 'document_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('document_id')}
                                >
                                    Document ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Document Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Document Category</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Number of Images</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '12.5%' }}>Gallery Restricted</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '12.5%' }}>Document Required</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Document Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .filter((row) => {
                                const isStatusMatch = statusFilter 
                                    ? (statusFilter === 'Active' ? row.is_active === 1 : row.is_active === 0) 
                                    : true;

                                return isStatusMatch;
                            })
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                                <TableRow key={row.document_id}>
                                    <TableCell align="center">{row.document_id}</TableCell>
                                    <TableCell align="center">{row.document_name}</TableCell>
                                    <TableCell align="center">{row.document_type}</TableCell>
                                    <TableCell align="center">{row.no_of_images}</TableCell>
                                    <TableCell align="center">
                                        {row.is_gallery_restricted === 1 ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.is_required === 1 ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            style={{
                                                backgroundColor: row.is_active === 1 ? '#0DBA78' : '#D14545',
                                                color: 'white',
                                                textTransform: 'none',
                                                pointerEvents: 'none',
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                            }}
                                        >
                                            {row.is_active === 1 ? 'Active' : 'Inactive'}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditModal(row)}
                                            sx={{
                                                backgroundColor: 'white',
                                                color: 'black',
                                                border: '1px solid black',
                                                textTransform: 'none',
                                                borderRadius: '8px',
                                                width: 'auto', // Or set a specific width
                                                minWidth: '120px', 
                                                '&:hover': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                                '&:active': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            View Details
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                
                {/* Pagination */}
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <div
                style={{
                    position: 'fixed', top: 65, backgroundColor: '#f9f9f9',
                    right: openAddDocument ? 0 : '-100%', height: '100%', width: '50%',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out', zIndex: 1000,overflowY: 'auto',padding: 20
                }}
            >
                <Box onClose={handleCloseAddDocument} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAddDocument}
                            style={{
                                position: 'absolute', top: '-15px', left: '1px', color: '#333',zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>

                        <Paper elevation={3} style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', backgroundColor: '#FFFFFF', borderRadius: '12px', }}>
                            {editMode && (
                                <div style={{
                                    display: 'flex', alignItems: 'center', backgroundColor: '#fff',
                                    padding: '10px 20px', border: '1px solid #E0E0E0', borderRadius: '8px',
                                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', marginBottom: '20px', marginTop: '50px',
                                }}>
                                    <Typography variant="body1" style={{ color: '#4A4A4A' }}>Document</Typography>
                                    <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => setIsActive(true)}
                                            style={{
                                                backgroundColor: isActive ? '#0DBA78' : '#F4F4F4',
                                                color: isActive ? '#FFFFFF' : '#9E9E9E',
                                                textTransform: 'none',
                                                borderRadius: '8px 0 0 8px',
                                                boxShadow: 'none',
                                                padding: '6px 16px',
                                                minWidth: '80px',
                                            }}
                                        >
                                            Enable
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => setIsActive(false)}
                                            style={{
                                                backgroundColor: !isActive ? '#D14545' : '#F4F4F4',
                                                color: !isActive ? '#FFFFFF' : '#9E9E9E',
                                                textTransform: 'none',
                                                borderRadius: '0 8px 8px 0',
                                                boxShadow: 'none',
                                                padding: '6px 16px',
                                                minWidth: '80px',
                                            }}
                                        >
                                            Disable
                                        </Button>
                                    </div>
                                </div>
                            )}

                            <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                {editMode ? 'Edit Customer Document' : 'Add Customer Document'}
                            </Typography>

                            {/* Input Fields */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Select City"
                                        select
                                        fullWidth
                                        variant="outlined"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    >
                                    {cities.map((cityObj) => (
                                            <MenuItem key={cityObj.city_id} value={cityObj.city_id}>
                                                {cityObj.city_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Document Name <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Document Name"
                                        fullWidth
                                        variant="outlined"
                                        value={documentName}
                                        onChange={(e) => setDocumentName(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Document Type <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Select Document Type"
                                        select
                                        fullWidth
                                        variant="outlined"
                                        value={documentType}
                                        onChange={(e) => setDocumentType(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    >
                                        {Object.entries(constants.CustomerDocumentTypes).map(([id, label]) => (
                                            <MenuItem key={id} value={label}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span> Number Of Images <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Number Of Images"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={noOfImages}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === '') { setNoOfImages(''); return; }
                                            const n = Number(val);
                                            if (Number.isInteger(n) && n > 0) {
                                                setNoOfImages(val);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                            if (e.key === '0') {
                                                const el = e.currentTarget;
                                                const isEmpty = el.value === '' || (el.selectionStart === 0 && el.selectionEnd === el.value.length);
                                                if (isEmpty) e.preventDefault();
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 1 }, // Prevent values less than or equal to zero
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>

                                {/* Gallery Restricted Switch */}
                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px 20px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{
                                                paddingLeft: '1px',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            Gallery Restricted
                                        </Typography>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    marginRight: '8px',
                                                    color: galleryRestricted ? '#4A4A4A' : '#9E9E9E',
                                                }}
                                            >
                                                {galleryRestricted ? 'Yes' : 'No'}
                                            </Typography>
                                            <Switch
                                                checked={galleryRestricted}
                                                onChange={(e) => setGalleryRestricted(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px 20px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{
                                                paddingLeft: '1px',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            Document Required
                                        </Typography>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    marginRight: '8px',
                                                    color: documentRequired ? '#4A4A4A' : '#9E9E9E',
                                                }}
                                            >
                                                {documentRequired ? 'Yes' : 'No'}
                                            </Typography>
                                            <Switch
                                                checked={documentRequired}
                                                onChange={(e) => setDocumentRequired(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px 20px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{
                                                paddingLeft: '1px',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            Document Number Required
                                        </Typography>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    marginRight: '8px',
                                                    color: documentNumberRequired ? '#4A4A4A' : '#9E9E9E',
                                                }}
                                            >
                                                {documentNumberRequired ? 'Yes' : 'No'}
                                            </Typography>
                                            <Switch
                                                checked={documentNumberRequired}
                                                onChange={(e) => setDocumentNumberRequired(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>

                            {/* Submit and Reset Buttons */}
                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#0065FF',
                                        color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseAddDocument}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>
                    </div>
                </Box>
            </div>
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                        
        </div>
    );
};

export default CustomerDocs;
